module.exports = __webpack_public_path__ + "img/13.db1849a5.png";